import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { ReactComponent as CrossIcon } from '../../../../src/styles/icon/cross.svg';
import authorize from './AuthorizePopup.module.scss';


AuthorizationPopup.propTypes = {
  fn: PropTypes.object.isRequired,
  getComponent: PropTypes.func.isRequired,
  authSelectors: PropTypes.object.isRequired,
  specSelectors: PropTypes.object.isRequired,
  errSelectors: PropTypes.object.isRequired,
  authActions: PropTypes.object.isRequired,
};

function AuthorizationPopup(props) {
  const refAuth = useRef();
  let {
    authSelectors,
    authActions,
    getComponent,
    errSelectors,
    specSelectors,
    fn: { AST = {} },
  } = props;
  let definitions = authSelectors.shownDefinitions();
  const Auths = getComponent('auths');

  function handleClickOutside(e) {
    if (refAuth.current && !refAuth.current.contains(e.target)) {
      close();
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleClickOutside, true);
    // document.body.classList.add('isHidden');
    const scrollPosition = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollPosition + 'px';
    document.body.style.width = '100%';
    return () => {
      // document.body.classList.remove('isHidden');
      window.removeEventListener('click', handleClickOutside, true);
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    };
  }, []);

  function close() {
    authActions.showDefinitions(false);
  };

  return (
    <div className="dialog-ux">
      <div className="backdrop-ux"></div>
      <div className={cn(authorize.authorize__modal, 'modal-ux')}>
        <div ref={refAuth} className="modal-dialog-ux">
          <div className="modal-ux-inner">
            <div className="modal-ux-header">
              <h3>Available Authorizations</h3>
              <button type="button" className="close-modal" onClick={close}>
                <CrossIcon className={authorize.authorize__icon}></CrossIcon>
              </button>
            </div>
            <div className="modal-ux-content">
              {definitions.valueSeq().map((definition, key) => {
                return (
                  <Auths
                    key={key}
                    AST={AST}
                    definitions={definition}
                    getComponent={getComponent}
                    errSelectors={errSelectors}
                    authSelectors={authSelectors}
                    authActions={authActions}
                    specSelectors={specSelectors}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthorizationPopup;
